module.exports = __webpack_public_path__ + "static/media/phone-alt-solid.6dbf65e5.svg";